import Link from 'next/link';
import cookie from 'react-cookies';
import NoSSR from '~/src/helpers/noSSR';
import { IMenuItem } from '~/src/api/content/menu';
import { ICurrentCity } from '~/src/store/reducers/city';
import * as ST from './styled';

interface IProps {
    menuItems: IMenuItem[];
    openCitySelect: () => void;
    city: ICurrentCity;
    cookieDomain?: string;
    isAuth: boolean;
    onClick: (item: string, menuType?: string) => void;
    onHover: (item: string, menuType?: string) => void;
}

const RightMenu = ({ menuItems, city, openCitySelect, cookieDomain, isAuth, onClick, onHover }: IProps): JSX.Element => {
    return (
        <ST.RightMenu>
            <ST.CitySelect
                onClick={openCitySelect}
                data-test='city-select-btn'
            >
                {city ? city.name : null}
            </ST.CitySelect>
            {
                menuItems.map(item => (
                    <ST.MenuItem isPromoted={!!item.promoted} key={item.id} data-test='right-menu-item'>
                        <Link href={item.link} prefetch={false}>
                            <a
                                onClick={() => onClick(item.title, 'right menu')}
                                onMouseEnter={() => onHover(item.title, 'right menu')}
                            >
                                {item.title}
                            </a>
                        </Link>
                        <ST.RightCollapsedMenu data-test='right-menu-subitem'>
                            {item.children?.map(childItem => (
                                <Link
                                    key={childItem.id}
                                    href={childItem.link}
                                    prefetch={false}
                                >
                                    <a
                                        onClick={() => onClick(childItem.title, 'right menu')}
                                        onMouseEnter={() => onHover(childItem.title, 'right menu')}
                                    >
                                        {childItem.title}
                                    </a>
                                </Link>
                            ))}
                        </ST.RightCollapsedMenu>
                    </ST.MenuItem>
                ))
            }
            <NoSSR>
                {!cookie.load('cityconfirm') && (
                    <ST.BlockForCitySelection>
                            <ST.CitySelectionCustom
                                city={city}
                                cookieDomain={cookieDomain}
                                isAuth={isAuth}
                                onBackClick={() => openCitySelect()}
                                data-test='city-selection'
                            />
                    </ST.BlockForCitySelection>
                )}
            </NoSSR>
        </ST.RightMenu>
    );
};

export default RightMenu;
